export const GET_ITEMS_TO_CONFIG = 'GET_ITEMS_TO_CONFIG';
export const CHANGE_SETTING = 'CHANGE_SETTING';
export const SET_SHOW_SECTION = 'SET_SHOW_SECTION';
export const CLEAN_STATE = 'CLEAN_STATE';
export const CHANGE_SETTING_LOCAL = 'CHANGE_SETTING_LOCAL';